import React from 'react';
import Vimeo from '@u-wave/react-vimeo';

export function StudyGuidePlayer({ videoId }) {
  return (
    <Vimeo
      video={videoId}
      autoplay
      responsive
    />
  );
}
